import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ServicesStore } from "../../../assets/store/service.store";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import ServiceCard from "../../../common/components/card/ServiceCard";
import Eyebrow from "../../../common/components/eyebrow/Eyebrow";
import {
  HeaderLeft,
  HeadingBlock,
} from "../../../common/components/layout/HeadingBlock";
import Description from "../../../common/components/text/Description";
import H2 from "../../../common/components/text/H2";
import { Theme } from "../../../common/themes/theme";

const Wrapper = styled.section`
  padding: 70px 50px;
  box-sizing: border-box;
  font-family: ${Theme.font.fontFamily.sans};
  background: ${Theme.color.background.light};

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    padding: 40px 20px;
  }
`;

const Header = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 48px;
  align-items: flex-end;
  justify-content: space-between;

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  background: ${Theme.color.background.light};
  overflow: hidden;

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${Theme.breakpoints.MOBILE}px) {
    grid-template-columns: 1fr;
  }
`;

function ServiceSection({ showViewAction = false }) {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <Header>
        <HeaderLeft>
          <HeadingBlock>
            <Eyebrow text={"What we do"} />
            <H2>
              Our <span>Services</span>
            </H2>

            <Description>
              From raw material to finished component — precision-machined parts
              with strict tolerances, fast lead times, and full quality
              traceability.
            </Description>
          </HeadingBlock>
        </HeaderLeft>

        {showViewAction && (
          <PrimaryButton
            onClick={() => {
              navigate("/services");
            }}
          >
            <Icon icon={"ic:outline-settings"} height={"20px"} /> View all
          </PrimaryButton>
        )}
      </Header>

      <Grid>
        {ServicesStore.map((service) => (
          <ServiceCard service={service} />
        ))}
      </Grid>
    </Wrapper>
  );
}

export default ServiceSection;
